import keyMirror from 'keymirror';

export const estados = keyMirror({
  INICIADO: true,
  FASE_1: true, /** ETAPA DE AUTO */
  FASE_2: true, /** ETAPA DE INTERLOCUTORIA */
  FASE_3: true, /** ETAPA SENTENCIA */
  ACEPTADO: true, /** EXPEDIENTE RESUELTO */
  RECHAZADO: true /** EXPEDIENTE RECHAZADO */
});